<template>
  <div></div>
</template>
<script>
  export default {
    mounted: function () {
       window.location.href = 'https://sso.saash.vdyoo.com/portal/login/A376024058'
    },
    methods: {
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/login.vue